// @flow
import React, { Component } from 'react';
import styles from 'components/WithSticky.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function WithSticky(WrappedComponent, classPositionFixed) {
  class ComponentWithSticky extends Component {
    /**
     * Implements propTypes().
     *
     * @return {Object} - propType object.
     * @prop {object} targetSticky - targetSticky.
     * @prop {function} closeModal - closeModal.
     * @prop {object} item - item
     */
    static propTypes = {
      classPositionFixed: PropTypes.func
    };

    render() {
      const { classWithSticky } = styles;
      return (
        <div
          className={classNames([
            classWithSticky,
            styles[classPositionFixed] || null
          ])}
        >
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }

  return ComponentWithSticky;
}

export default WithSticky;



// WEBPACK FOOTER //
// ./src/Common/HOC/WithSticky/index.js